import type * as api from '@gitbook/api-client';
import { DateShortRelative } from '@gitbook/react-uikit';
import {
    Heading,
    LabeledContainer,
    LabeledContainerBody,
    LabeledContainerHeader,
    ListItem,
    ListItemBody,
    ListItemDescription,
    ListItemDetail,
    ListItemIndicator,
} from '@gitbook/spine-react';

import { UserAvatar } from '../Users';

/**
 * Section for presenting the creator of a change request.
 */
export function ChangeRequestCreatedBySection(props: { changeRequest: api.ChangeRequest }) {
    const { changeRequest } = props;

    return (
        <LabeledContainer>
            <LabeledContainerHeader>
                <Heading>Created by</Heading>
            </LabeledContainerHeader>
            <LabeledContainerBody>
                <ListItem compact>
                    <ListItemIndicator>
                        <UserAvatar
                            size="md"
                            tooltip={false}
                            user={changeRequest.createdBy}
                            className="mr-1"
                        />
                    </ListItemIndicator>
                    <ListItemBody>
                        <ListItemDescription>
                            {changeRequest.createdBy.displayName}
                        </ListItemDescription>
                        <ListItemDetail>
                            <DateShortRelative value={changeRequest.createdAt} onlyDate={false} />
                        </ListItemDetail>
                    </ListItemBody>
                </ListItem>
            </LabeledContainerBody>
        </LabeledContainer>
    );
}
